// DetailSpecs — section 6. Canonical detail.html lines 502–568.
//
// Subtype-aware: render only the dl that matches the property's
// subtype. Branch is screen-local — no registry, no dispatch.

import {
  COMMERCIAL_SUITABILITY_LABELS,
  CONDITION_LABELS,
  FURNITURE_LABELS,
  HEATING_LABELS,
  LAND_PURPOSE_LABELS,
  WALL_LABELS,
  booleanLabel as specBooleanLabel,
  enumLabel,
} from "../../realty/lib/specLabels";

const muted = () => <span className="muted">—</span>;

const val = (value) =>
  value === null || value === undefined || value === "" ? muted() : value;

const boolLabel = (value) => {
  const label = specBooleanLabel(value);
  return label == null ? muted() : label;
};

const enumVal = (labels, value) => {
  const label = enumLabel(labels, value);
  return label == null ? muted() : label;
};

function DetailSpecs({ property }) {
  const residential = property.residential || null;
  const land = property.land || null;
  const commercial = property.commercial || null;
  const isApartment = property.property_type === "apartment";
  const isHouse = property.property_type === "house";

  return (
    <section className="detail-specs">
      <div className="container">
        <div className="row">
          <h2 className="section-title">Характеристики</h2>

          {residential ? (
            <dl className="specs-grid" data-subtype="residential">
              <div className="spec-row">
                <dt>Загальна площа</dt>
                <dd>
                  {val(residential.total_area_m2)} м<sup>2</sup>
                </dd>
              </div>
              <div className="spec-row">
                <dt>Житлова площа</dt>
                <dd>
                  {val(residential.living_area_m2)} м<sup>2</sup>
                </dd>
              </div>
              <div className="spec-row">
                <dt>Площа кухні</dt>
                <dd>
                  {val(residential.kitchen_area_m2)} м<sup>2</sup>
                </dd>
              </div>
              <div className="spec-row">
                <dt>Кімнат</dt>
                <dd>{val(residential.rooms)}</dd>
              </div>
              <div className="spec-row">
                <dt>Санвузлів</dt>
                <dd>{val(residential.bathrooms)}</dd>
              </div>
              <div className="spec-row">
                <dt>Поверх</dt>
                <dd>
                  {val(residential.floor)} із {val(residential.total_floors)}
                </dd>
              </div>
              <div className="spec-row">
                <dt>Рік побудови</dt>
                <dd>{val(residential.year_built)}</dd>
              </div>
              {isHouse ? (
                <div className="spec-row">
                  <dt>Площа ділянки</dt>
                  <dd>
                    {val(residential.land_area_m2)} м<sup>2</sup>
                  </dd>
                </div>
              ) : null}
              <div className="spec-row">
                <dt>Стіни</dt>
                <dd>{enumVal(WALL_LABELS, residential.walls)}</dd>
              </div>
              <div className="spec-row">
                <dt>Опалення</dt>
                <dd>{enumVal(HEATING_LABELS, residential.heating)}</dd>
              </div>
              <div className="spec-row">
                <dt>Ремонт</dt>
                <dd>{enumVal(CONDITION_LABELS, residential.condition)}</dd>
              </div>
              <div className="spec-row">
                <dt>Меблі</dt>
                <dd>{enumVal(FURNITURE_LABELS, residential.furniture)}</dd>
              </div>
              {isApartment ? (
                <div className="spec-row">
                  <dt>Житловий комплекс</dt>
                  <dd>{val(residential.residential_complex)}</dd>
                </div>
              ) : null}
              <div className="spec-row">
                <dt>Балкон</dt>
                <dd>{boolLabel(residential.has_balcony)}</dd>
              </div>
              <div className="spec-row">
                <dt>Парковка</dt>
                <dd>{boolLabel(residential.has_parking)}</dd>
              </div>
            </dl>
          ) : null}

          {land ? (
            <dl className="specs-grid" data-subtype="land">
              <div className="spec-row">
                <dt>Площа</dt>
                <dd>
                  {val(land.area_m2)} м<sup>2</sup>
                </dd>
              </div>
              <div className="spec-row">
                <dt>Цільове призначення</dt>
                <dd>{enumVal(LAND_PURPOSE_LABELS, land.purpose)}</dd>
              </div>
              <div className="spec-row">
                <dt>Під&apos;їзна дорога</dt>
                <dd>{boolLabel(land.has_road_access)}</dd>
              </div>
              <div className="spec-row">
                <dt>Комунікації</dt>
                <dd>{boolLabel(land.has_utilities)}</dd>
              </div>
            </dl>
          ) : null}

          {commercial ? (
            <dl className="specs-grid" data-subtype="commercial">
              <div className="spec-row">
                <dt>Загальна площа</dt>
                <dd>
                  {val(commercial.total_area_m2)} м<sup>2</sup>
                </dd>
              </div>
              <div className="spec-row">
                <dt>Поверх</dt>
                <dd>{val(commercial.floor)}</dd>
              </div>
              <div className="spec-row">
                <dt>Призначення</dt>
                <dd>{enumVal(COMMERCIAL_SUITABILITY_LABELS, commercial.suitable_for)}</dd>
              </div>
              <div className="spec-row">
                <dt>Стіни</dt>
                <dd>{enumVal(WALL_LABELS, commercial.walls)}</dd>
              </div>
              <div className="spec-row">
                <dt>Опалення</dt>
                <dd>{enumVal(HEATING_LABELS, commercial.heating)}</dd>
              </div>
              <div className="spec-row">
                <dt>Ремонт</dt>
                <dd>{enumVal(CONDITION_LABELS, commercial.condition)}</dd>
              </div>
              <div className="spec-row">
                <dt>Меблі</dt>
                <dd>{enumVal(FURNITURE_LABELS, commercial.furniture)}</dd>
              </div>
            </dl>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default DetailSpecs;
